var canvas, canvas2, text, fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1000, cHeight = 1000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop, lampText,
    scale_factor, newheight, leftOb,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 451, sizeB1H = 526,
    sizeB2W = 300, sizeB2H = 76;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});


addModify(window['canvas2']);



fabric.Text.prototype.textBaseline = 'alphabetic';

/* ---------- GOLD GRADIENT ---------- */
function createGoldGradient(textObj){
  textObj.initDimensions();
  return new fabric.Gradient({
    type:'linear',
    gradientUnits:'pixels',
    coords:{ x1:0, y1:0, x2:0, y2:textObj.height },
    colorStops:[
      {offset:0,color:'#ffd352'},
      {offset:0.25,color:'#f8c633'},
      {offset:0.55,color:'#d7a225'},
      {offset:0.75,color:'#f5ba2e'},
      {offset:1,color:'#ffe96d'}
    ]
  });
}

/* ---------- SHADOW ---------- */
function applyEmbossShadow(obj){
  obj.set('shadow', new fabric.Shadow({
    color:'rgba(0,0,0,0.58)',
    blur:4,
    offsetX:2,
    offsetY:2
  }));
}

/* ---------- TEXT FIT FUNCTION ---------- */
function fitText(textObj, maxWidth, baseSize){

  // reset to original size first
  textObj.set({ fontSize: baseSize });
  textObj.initDimensions();

  let size = baseSize;

  while(textObj.width > maxWidth && size > 5){
    size--;
    textObj.set({ fontSize: size });
    textObj.initDimensions();
  }
}

/* ---------- TEXT 1 ---------- */
window.text1Page = new fabric.Text('check',{
  left:495,
  top:585,
  fontSize:115,
  fontFamily:'Elicit Script',
  textAlign:'center',
  lockMovementX:true,
  lockMovementY:true,
  hasControls:false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

text1Page.set({ fill:createGoldGradient(text1Page) });
applyEmbossShadow(text1Page);

canvas2.add(text1Page);

canvas2.renderAll();

/* ---------- INPUT ---------- */
const input = document.getElementById('text_1');

input.addEventListener('focus',()=>{
  if(text1Page.text === 'Maryam ki Eidi'){
    text1Page.set('text','');
    canvas2.renderAll();
  }
});

input.addEventListener('input',(e)=>{

  const value = e.target.value;

  text1Page.set('text', value);

  // reset to big size if text is empty
  if(value.length === 0){
    text1Page.set({ fontSize:115 });
  }

  fitText(text1Page,790,115);

  text1Page.bringToFront();

  canvas2.renderAll();

});





function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  canvas.remove(heartimg).renderAll();

  fabric.Image.fromURL(imgurl, function(heartimg) {
    heartimg.set({ crossOrigin: 'anonymous' });
    heartimg.set({
      left: 497,
      top: 406,
      originX: 'center',
      originY: 'center'
    });
     heartimg.scaleToHeight(available_height);
    heartimg.clipPath = heartClip;
    canvas2.add(heartimg);
    canvas2.renderAll();
  }, { crossOrigin: 'anonymous' });

  
  
}



function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});


document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});


jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});




/* ---------- FONT CHANGE ---------- */
jQuery(document).on('change', '.fontFamily', function () {
  const fontID = jQuery(this).attr('data-canvas');
  const textObID = jQuery(this).attr('data-obj');

  const canvas = window[fontID];
  const textObj = window[textObID];

  if (!textObj) return;

  // 🔥 change font
  textObj.set({
    fontFamily: this.value,
    scaleX: 1,
    scaleY: 1
  });

  // 🔥 force recalculation
  textObj.initDimensions();
  textObj.setCoords();

  // 🔥 refit text box
  fitText(text1Page,790,115);

  // 🔥 keep selected color (gradient / solid)
  const $activeBg = $('#background_design a.active');
if ($activeBg.length) {
  syncTextColorFromBackground($activeBg);
}


  canvas.renderAll();
});



jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});



jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Maryam ki Eidi');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});


/* fetch Call */
var size,thumbnail;
var loadedObject,enterName,smallDesc,chooseFont,chooseFont2,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 406;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    window['canvas2'] = canvas.toDataURL('image/png');
    enterName = jQuery('.enter_name input').val();
    smallDesc = jQuery('.small_desc textarea').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    chooseFont2 = jQuery('.choose_font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#enterName').val(enterName);
      jQuery('#smallDesc').val(smallDesc);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#chooseFont2').val(chooseFont2);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      loader.addClass('hidden');
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});



function resizeObjects(canvas){
  window['text1Page'].setCoords();
  canvas.renderAll();
  var lampText = new fabric.Group([window['text1Page']]);
  lampText.set({
    left: cWidth / 2,
    top: cHeight / 2,
    originX: 'center',
    originY: 'center'
  });
  lampText.scaleToWidth('800');
  lampText.setCoords();
  canvas.renderAll();
}

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}